import ApiClient from './ApiClient';

class ProjectMilestones extends ApiClient {
  constructor() {
    super('milestones', { accountScoped: true });
    this.projectId = null;
  }

  get url() {
    return `${this.baseUrl()}/projects/${this.projectId}/milestones`;
  }

  get(projectId) {
    this.projectId = projectId;
    return super.get();
  }

  create(projectId, data) {
    this.projectId = projectId;
    return super.create({ milestone: data });
  }

  update(projectId, id, data) {
    this.projectId = projectId;
    return super.update(id, { milestone: data });
  }

  delete(projectId, id) {
    this.projectId = projectId;
    return super.delete(id);
  }
}

export default new ProjectMilestones();
